
define('text!common/views/discussion/comment-count.html',[],function () { return '<a class="fc-trail__count fc-trail__count--commentcount" href="<%=url%>" data-link-name="Comment count"><%=icon%> <%=count%></a>\n';});

